export class StatesNotcer {
  public static readonly ALL = '0';
  public static readonly DELIVERED = '1';
  public static readonly TRAY = '2';
  public static readonly VISUALIZED = '3';
}
